/* eslint-disable */
// @ts-nocheck

/* eslint-enable prettier/prettier */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable import/no-unresolved */

/* global I18n */

import React, { useCallback, useEffect } from "react";
import { TUtilStateSetFunc } from "../../../../../../src/types/utils";

import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";

import { Formik, Form } from "formik";
import SurveyQuestionInput from "./SurveyQuestionInput";
import DataService from "@untyped-services/dataService";
import SurveySubmitButton from "./SurveySubmitButton";
import WidgetCard from "@untyped-shared/materialUI/widgetCard";
import SurveyDescription from "./SurveyDescription";
import SurveyAnonymouseNote from "./SurveyAnonymousNote";
import ThankYouMessage from "./ThankYouMessage";
import SurveyTitle from "./SurveyTitle";
import { object as yupObject, string as yupString } from "yup";

import {
  selectQuestionsForActiveSurvey,
  getSurveyQuestions,
} from "@untyped-store/slices/survey/surveysQuestionsSlice";

import {
  getSurvey,
  selectActiveSurvey,
} from "@untyped-store/slices/surveysSlice";

import { selectIsFocusViewTemplate } from "@untyped-store/slices/metaSlice";

const useStyles = makeStyles(() => ({
  root: {
    fontSize: "1.3rem",
    fontFamily: '"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
    color: "#717171",
  },
  hint: {
    color: "#B01403",
  },
}));

type TProps = {
  setShowSuccessMessage: TUtilStateSetFunc<boolean>;
};

function SurveyForm({ setShowSuccessMessage }: TProps) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const dataService = new DataService();
  const survey = useSelector(selectActiveSurvey);
  const isFocusViewTemplate = useSelector(selectIsFocusViewTemplate);
  const surveyQuestions = useSelector(selectQuestionsForActiveSurvey);
  const jwt = useSelector((state) => state.jwt.token);

  useEffect(() => {
    dispatch(getSurveyQuestions({ surveyId: survey.id }));
  }, [survey.id]);

  // Allow to fill the form via JS, used for load test scripts
  // https://github.com/jaredpalmer/formik/issues/2212
  window.surveyFormRef = React.createRef();

  const sendNewAttempt = useCallback(
    (values, { setSubmitting }) => {
      const attemptParams = {
        answers: { ...values },
        language: I18n.locale,
      };

      const url = `/api/surveys/${survey.id}/attempt`;
      dataService
        .postData(url, attemptParams, jwt)
        .then(() => {
          setShowSuccessMessage(true);
          dispatch(getSurvey({ surveyId: survey.id }));
          // Don't re-enable the button on success - the form will be replaced
          // This prevents duplicate submissions during the UI update
        })
        .catch((err) => {
          alert(`${I18n.t("surveys.new_attempt.error")}: ${err}`);
          setSubmitting(false); // Only re-enable on error
        });
    },
    [survey],
  );

  const inits = {};
  surveyQuestions.forEach((question) => {
    inits[question.id] = "";
  });

  // Validate that there are not unanswered mandatory questions
  const validationObject = {};
  surveyQuestions.forEach((question) => {
    if (question.mandatory) {
      validationObject[question.id] = yupString()
        .trim()
        .required(I18n.t("surveys.mandatory_question_error"));
    }
  });
  const mandatorySchema = yupObject().shape(validationObject);

  const mandatoryHint = (
    <p id="mandatory-hint">{I18n.t("surveys.required_questions")}</p>
  );

  const isAnyQuestionMandatory = surveyQuestions.some(
    (question) => question.mandatory,
  );

  const form = (
    <>
      <SurveyAnonymouseNote
        note={
          survey.anonymous
            ? I18n.t("surveys.is_anonymous")
            : I18n.t("surveys.not_anonymous")
        }
      />

      <Formik
        validateOnChange={false}
        validateOnBlur={false}
        innerRef={window.surveyFormRef}
        initialValues={inits}
        validationSchema={mandatorySchema}
        onSubmit={sendNewAttempt}
      >
        {({ errors }) => (
          <Form id="new_survey_attempt">
            {isAnyQuestionMandatory && mandatoryHint}
            <section className="comment-list block widget">
              {surveyQuestions.map((question, index) => {
                return (
                  <SurveyQuestionInput
                    question={question}
                    questionNumber={index + 1}
                    key={question.id}
                    error={errors[question.id]}
                  />
                );
              })}

              <SurveySubmitButton />
            </section>
          </Form>
        )}
      </Formik>
    </>
  );

  const wrapper = (
    <section
      id="survey"
      className={classes.root}
      aria-label={I18n.t("frontend.survey_form")}
    >
      {!isFocusViewTemplate && <SurveyTitle text={survey.name} />}
      {survey.description && survey.canParticipate && (
        <>
          <SurveyDescription text={survey.description} />
          <hr className="line line-lg line-dashed pull-in" />
        </>
      )}
      {survey.canParticipate ? (
        form
      ) : (
        <ThankYouMessage withDottedLine={!isFocusViewTemplate} />
      )}
    </section>
  );

  const widgetStyle = <WidgetCard head={survey.name} body={wrapper} />;
  const plainStyle = wrapper;

  return isFocusViewTemplate ? widgetStyle : plainStyle;
}

export default SurveyForm;
